<!--<p *ngIf="!id" fxLayout="row" fxLayoutAlign="start center" class="p-12px-0">
  <label fxFlex="30" fxShow fxHide.xs>{{label}}</label>
  <mat-select fxFlex.xs="100" fxFlex.gt-xs="50" [placeholder]="placeholder" [(ngModel)]="text" [multiple]="multiple" [required]="required" [disabled]="disabled">
       <mat-select fxFlex.xs="100" fxFlex.gt-xs="50" [placeholder]="placeholder" [(ngModel)]="text" [multiple]="multiple" [required]="required"> 
    <mat-option *ngFor="let opt of options" [value]="opt.name">
      <span>{{opt.name}}</span>
    </mat-option>
  </mat-select>
</p>-->

<!--<p *ngIf="id" fxLayout="row" fxLayoutAlign="start center" class="p-12px-0">
  <label fxFlex="30" fxShow fxHide.xs>{{label}}</label>
  <mat-select fxFlex.xs="100" fxFlex.gt-xs="50" [placeholder]="placeholder" [id]="id" [(ngModel)]="text" [multiple]="multiple" [required]="required" [disabled]="disabled">
       <mat-select fxFlex.xs="100" fxFlex.gt-xs="50" [placeholder]="placeholder" [id]="id" [(ngModel)]="text" [multiple]="multiple" [required]="required" > 
    <mat-option *ngFor="let opt of options" [value]="opt.id || opt.id">
      <span>{{opt.name}}</span>
    </mat-option>
  </mat-select>
</p>-->

<div class="container">
  <div *ngIf="id" class="row">
    <!-- Stack below 768px; original side-by-side split from tablet up. -->
    <div class="col-12 col-md-4 pt-10px-important">
      <label>{{label}}</label>
    </div>
    <div class="col-12 col-md-5 w-full-important">
      <mat-select [placeholder]="placeholder" [id]="id" [(ngModel)]="text" [multiple]="multiple" [required]="required" [disabled]="disabled" class="w-full-important">
        <!-- <mat-select fxFlex.xs="100" fxFlex.gt-xs="50" [placeholder]="placeholder" [id]="id" [(ngModel)]="text" [multiple]="multiple" [required]="required" > -->
      <mat-option *ngFor="let opt of options" [value]="opt.id || opt.id" class="w-full-important">
        <span>{{opt.name}}</span>
      </mat-option>
    </mat-select>
    </div>
  </div>
</div>

<!-- <div class="container">
  <div *ngIf="id" class="row">
    <div class="col-4 pt-10px-important">
      <label>{{label}}</label>
    </div>
    <div class="col-5 w-full-important">
      <mat-select [placeholder]="placeholder" [id]="id" [(ngModel)]="text" [multiple]="multiple" [required]="required" [disabled]="disabled" class="w-full-important">
      <mat-option *ngFor="let opt of options" [value]="opt.name" class="w-full-important">
        <span>{{opt.name}}</span>
      </mat-option>
    </mat-select>
    </div>
  </div>
</div> -->


